module.exports = __webpack_public_path__ + "static/media/1.6e235a76.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/rhand/1.png
// module id = 1439
// module chunks = 0